import { render, staticRenderFns } from "./PlanBadge.vue?vue&type=template&id=edbd3af2&scoped=true"
import script from "./PlanBadge.vue?vue&type=script&lang=js"
export * from "./PlanBadge.vue?vue&type=script&lang=js"
import style0 from "./PlanBadge.vue?vue&type=style&index=0&id=edbd3af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbd3af2",
  null
  
)

export default component.exports